"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIN_QUERY_ID_THIRD = exports.MAIN_QUERY_ID_SECOND = exports.MAIN_QUERY_ID = exports.MAIN_QUERIES = void 0;
var MAIN_QUERY_ID = exports.MAIN_QUERY_ID = 'main';
var MAIN_QUERY_ID_SECOND = exports.MAIN_QUERY_ID_SECOND = "".concat(MAIN_QUERY_ID, "-2");
var MAIN_QUERY_ID_THIRD = exports.MAIN_QUERY_ID_THIRD = "".concat(MAIN_QUERY_ID, "-3");
var MAIN_QUERIES = exports.MAIN_QUERIES = [MAIN_QUERY_ID, MAIN_QUERY_ID_SECOND, MAIN_QUERY_ID_THIRD];